import { ResourceTypes } from 'types/types'
import { pluralizeForURL } from './resources'

const Routes = {
    Home: '/catalog',
    SignUp: '/signup',
    SignIn: '/login',
    Paths: '/paths',
    Catalog: '/catalog',
    Supporters: '/supporters',
    CatalogAvailable: '/catalog/available',
    CatalogPersonal: '/catalog/personal',
    Pricing: '/pricing',
    SortingQuiz: '/sorting-quiz',
    SortingQuizResults: '/quiz-results',
    MyPath: '/paths/my-path',

    VerifyEmail: (email: string) => `/verify-email?email=${email}`,
    ForgotPassword: '/forgot-password',
    ResetPassword: '/reset-password',

    AccountSettings: '/settings/account',
    ProfileSettings: '/settings/profile',
    PathSettings: '/settings/path',
    PlanSettings: '/settings/plan',

    Wiki: '/wiki',

    WikiLanguages: '/wiki/languages',
    WikiLanguage: (slug: string) => `/wiki/languages/${slug}`,

    WikiTools: '/wiki/tools',
    WikiTool: (slug: string) => `/wiki/tools/${slug}`,

    WikiSubjects: '/wiki/subjects',
    WikiSubject: (slug: string) => `/wiki/subjects/${slug}`,

    WikiRoles: '/wiki/roles',
    WikiRole: (slug: string) => `/wiki/roles/${slug}`,

    WikiDomains: '/wiki/domains',

    Blog: '/blog',

    Path: (slug: string) => `/paths/${slug}`,
    Course: (slug: string) => `/courses/${slug}`,
    LearningItem: (itemType: 'courses' | 'paths', slug: string) => `/${itemType}/${slug}`,

    Resource: (itemType: 'courses' | 'paths', itemId: string, resourceType: ResourceTypes, resourceId: string) =>
        `/${itemType}/${itemId}/${pluralizeForURL(resourceType)}/${resourceId}`,

    Quiz: (itemType: 'courses' | 'paths', itemId: string, quizId: string, questionNumber?: number) =>
        `/${itemType}/${itemId}/quizzes/${quizId}/${questionNumber}`,

    Lesson: (itemType: 'courses' | 'paths', itemId: string, lessonId: string) =>
        `/${itemType}/${itemId}/lessons/${lessonId}`,

    Exercise: (itemType: 'courses' | 'paths', itemId: string, lessonId: string, exerciseNumber: number) =>
        `/${itemType}/${itemId}/lessons/${lessonId}/${exerciseNumber}`,

    Category: (slug: string) => `/catalog/categories/${slug}`,

    OGImageTitleCTA: (title: string, caption: string) =>
        `${process.env.NEXT_PUBLIC_DEVV_WEBAPP_URL}/api/og?title=${title}&caption=${caption}`,
}

export const toAbsoluteUrl = (path: string) => `${process.env.NEXT_PUBLIC_DEVV_WEBAPP_URL}${path}`

export const ProtectedRoutes = [
    '/resources/*', // Wildcard route doesn't work
    Routes.AccountSettings,
    Routes.ProfileSettings,
    Routes.PathSettings,
    Routes.PlanSettings,
]

export default Routes
